import { api, stickyMessage } from './util';

/**
 * Changing text for button when clicked
 */
(function ($) {
	$(document).on('click', '.js-user-async-export', function (e) {
		e.preventDefault();

		var btn = $(this);
		var ico = btn.find('.icon');
		var txt = btn.find('.txt');
		var href = btn.attr('href') || btn.data('href');
		var text = btn.data('replacement-text');
		var originalText = txt.text();

		if (btn.hasClass('disabled')) {
			return;
		}

		btn.addClass('disabled');
		ico.removeClass('icon-download');
		ico.addClass('icon-hourglass');
		txt.text(text);

		/**
		 * @param {{
		 *  export: {
		 *  downloadUrl: string,
		 *  asyncNotification: {
		 *      email: string
		 *    }
		 *  }
		 * }} response
		 */
		api
			.get(href)
			.done(function (response) {
				if (response.status.success === false) {
					stickyMessage.show('error', response.status.message);
					return;
				}

				if (response.export.downloadUrl) {
					window.location.href = response.export.downloadUrl;
				} else {
					stickyMessage.show(
						'success',
						'Export je příliš velký. Po zpracování vám pošleme odkaz pro stažení na email ' +
							response.export.asyncNotification.email
					);
				}
			})
			.always(function () {
				btn.removeClass('disabled');
				ico.addClass('icon-download');
				ico.removeClass('icon-hourglass');
				txt.text(originalText);
			});
	});
})(jQuery);
